import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, ModalDirective } from 'ngx-bootstrap';
import { forkJoin, Observable } from 'rxjs';
import swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';

import { ServicesService } from '../../services/services.service';
import { ChatService } from './chat-service';
import { InstructionDialogComponent } from './instruction-dialog/instruction-dialog.component';
import { MaintenanceChatDialogComponent } from './maintenance-chat-dialog/maintenance-chat-dialog.component';
import { MaintenanceRequestStatus } from './maintenance-request-status';
import { MaintenanceRequestService } from './maintenance-request.service';
import { ChatDiscussion, ChatDiscussions } from './models/chat-discussion';
import { TableColumn, TableColumns } from './models/field';
import { QuoteDialog } from './quote-dialog/quote-dialog.component';
import { ViewMaintenanceRequestDialogComponent } from './view-request-dialog/view-maintenance-request-dialog.component';

@Component({
  selector: 'app-maintenance-request',
  templateUrl: './maintenance-request.component.html',
  styleUrls: ['./maintenance-request.component.scss']
})
export class MaintenanceRequestComponent implements OnInit, OnDestroy {
  columns: TableColumns = [

    new TableColumn({ translationKey: 'MaintenanceRequest.customer_name', class: 'responsive-td' }),
    new TableColumn({ translationKey: 'MaintenanceRequest.customer_email', class: 'responsive-td' }),
    new TableColumn({ translationKey: 'MaintenanceRequest.assigned' }),
    new TableColumn({ translationKey: 'MaintenanceRequest.status' }),
    new TableColumn({ translationKey: 'MaintenanceRequest.action' }),
  ]

  flagQuote = [];
  maintenanceRequests = [];
  employeeLists = [];
  token: string;
  routeData: string;
  requestId: number;
  isShowEmpListModal: boolean;
  isShowQRCodeModal: boolean;
  qrCodeData: string = null;
  qrCodeFileName: string = null;
  isListData = true;
  quote: string;
  closeResult: string;
  requestObject: any;
  discussions: ChatDiscussions = [];

  messages: any[] = [];
  pollInterval: NodeJS.Timer = null;

  STATUS = MaintenanceRequestStatus;

  @ViewChild('maintenanceChat') maintenanceChat: ModalDirective;
  
  constructor(private readonly _services: ServicesService,
    private readonly maintenanceRequestService: MaintenanceRequestService,
    private readonly modalService: NgbModal,
    private readonly bsModalService: BsModalService,
    private readonly router: Router,
    public readonly dialog: MatDialog,
    private readonly chatService: ChatService) {
    this.isShowEmpListModal = false;
    this.isShowQRCodeModal = false;
  }

  ngOnInit() {
    this._services.checkToken('status');
    this.token = localStorage.getItem('userToken');
    this.getMaintenanceRequests();
    this.getEmpList();
  }

  ngOnDestroy(): void {
    clearInterval(this.pollInterval);
  }

  open(content, type, modalDimension, maintenanceRequest: any) {
    this.requestObject = maintenanceRequest;


    if (modalDimension === 'sm' && type === 'modal_mini') {
      this.modalService.open(content, { windowClass: 'modal-mini', size: 'sm', centered: true }).result.then((result) => {
        this.closeResult = 'Closed with: $result';
      }, (reason) => {
        this.closeResult = 'Dismissed $this.getDismissReason(reason)';
      });
    } else if (modalDimension === '' && type === 'Notification') {
      this.modalService.open(content, { windowClass: 'modal-danger', centered: true }).result.then((result) => {
        this.closeResult = 'Closed with: $result';
      }, (reason) => {
        this.closeResult = 'Dismissed $this.getDismissReason(reason)';
      });
    } else {
      this.modalService.open(content, { centered: true }).result.then((result) => {
        this.closeResult = 'Closed with: $result';
      }, (reason) => {
        this.closeResult = 'Dismissed $this.getDismissReason(reason)';
      });
    }
  }

  statusIs(request: any, ...statuses: MaintenanceRequestStatus[]): boolean {
    return statuses.includes(request.status);
  }

  private async getMaintenanceRequests(): Promise<void> {
    this.isListData = true;
    this.maintenanceRequestService.getMaintenanceRequests().subscribe(async (result: any) => {
      this.isListData = false;

      this.maintenanceRequests = result.maintenance_requests;

      this.flagQuote = new Array(this.maintenanceRequests.length).fill(false);

      await this.checkForNewMessages();
      this.startPollingForMessages();
    });
  }

  private checkForNewMessages(): Promise<void> {
    return new Promise((resolve) => {
      const discussions$: Observable<ChatDiscussion>[] = [];
      this.discussions = [];

      this.maintenanceRequests.forEach(maintenanceRequest => {
        discussions$.push(this.chatService.fetchDiscussion(maintenanceRequest.id));
      });

      forkJoin(discussions$).subscribe((discussions: ChatDiscussions) => {
        this.discussions = discussions;
        this.maintenanceRequests.forEach(request => {
          request.discussion = discussions.find(d => d.maintenanceRequestId == request.id);
        });

        resolve();
      });
    })

  }

  /**
   * This polling should be eventually replaced by websockets
   */
  private startPollingForMessages() {
    this.pollInterval = setInterval(() => {
      this.checkForNewMessages();
    }, 5000);
  }

  onRefresh() {
    this.getMaintenanceRequests();
  }

  onChangeStatus(id, status, event) {
    const oldText = event.target.innerHTML;
    event.target.innerHTML = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
    event.target.disabled = true;
    const data = { 'request_id': id, 'status': status };
    this.maintenanceRequestService.changeMaintenanceRequest(data).subscribe((result: any) => {
      event.target.innerHTML = oldText;
      event.target.disabled = false;
      this.getMaintenanceRequests();
    });
  }

  sendQuote(data, index) {
    if (typeof data.status != 'string')
      data.status = data.status.toString();
    this.maintenanceRequestService.updateMaintenanceRequest(data).subscribe((result: any) => {
      //this._services.checkToken(result.status)
      //if(result.status == '200')
      this.flagQuote[index] = true;

      this.getMaintenanceRequests();
      swal({
        title: 'Success',
        text: 'Send Quote Successfully',
        type: 'success',
        showCancelButton: false,
        confirmButtonColor: 'rgb(17, 205, 239)',
        cancelButtonColor: 'rgb(245, 54, 92)',
        confirmButtonText: 'Yes'
      });
    },
      (err: HttpErrorResponse) => {
        swal({
          title: 'Fail',
          text: JSON.stringify(err),
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        });
      });
  }

  async openDialog(maintenanceRequest, index: number) {

    const dialogRef = this.dialog.open(QuoteDialog, {
      width: '350px',
      data: ''
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      if (!isNullOrUndefined(result)) {
        maintenanceRequest.quote = result;
        maintenanceRequest.maintenance_request_id = maintenanceRequest.id;
        maintenanceRequest.latitude = maintenanceRequest.latitude.toString();
        maintenanceRequest.longitude = maintenanceRequest.longitude.toString();
        this.sendQuote(maintenanceRequest, index);
      }
    });
  }

  public openEmployeeInstruction(maintenanceRequest: any): void {
    maintenanceRequest.employee_instructions = maintenanceRequest.employee_instructions || '';
    const dialogRef = this.dialog.open(InstructionDialogComponent, {
      width: '350px',
      data: maintenanceRequest
    });

    dialogRef.afterClosed().subscribe((instruction: string) => {
      if (!isNullOrUndefined(instruction)) {
        maintenanceRequest.employee_instructions = instruction;
      }
    });
  }

  public viewRequest(request: any, index: number): void {
    const ref = this.bsModalService.show(ViewMaintenanceRequestDialogComponent, {
      class: 'modal-lg',
      initialState: {
        request: request
      }
    });
  }

  getEmpList() {
    const data = { page: 0, search: {}, sort: {} };
    this.maintenanceRequestService.getEmployeeList(data).subscribe((res: any) => {
      this.employeeLists = res.result;
    });
  }

  getEmployeeFullName(employeeId: number): string {
    const employee = this.getEmployee(employeeId);
    return isNullOrUndefined(employee) 
      ? '-'
      : `${employee.first_name} ${employee.last_name}`;
    
  }

  getEmployee(employeeId: number): any {
    return this.employeeLists.find(emp => emp.id === employeeId);
  }

  onAssign(id: number, status: string, event: Event) {
    const buttonElement: HTMLButtonElement = event.target as HTMLButtonElement;

    const oldText = buttonElement.innerHTML;
    buttonElement.innerHTML = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
    buttonElement.disabled = true;
    const data = {
      'request_id': this.requestObject.id,
      'status': status,
      'employee_id': id,
    };


    this.maintenanceRequestService.changeMaintenanceRequest(data).subscribe((res: any) => {      
      swal({
        title: '',
        text: 'Assigned successfully .',
        type: 'success',
        showCancelButton: false
      }).then(result => {
        buttonElement.innerHTML = oldText;
        buttonElement.disabled = false;
      });
    });
  }

  saveRequestId(id) {
    this.requestId = id;
    this.isShowEmpListModal = true;
  }


  constructionDetails(construction_id) {
    this.router.navigateByUrl('construction-info?const_id=' + construction_id);
  }

  startChat(maintenanceRequest: any) {
    const ref = this.bsModalService.show(MaintenanceChatDialogComponent, {
      class: 'modal-lg',
      initialState: {
        request: maintenanceRequest
      }
    });

    ref.content.markedAsRead.subscribe((requestId: number) => {
      const request = this.maintenanceRequests.find(req => req.id === requestId);
      request.discussion.markAsRead();
    })
  }
}
